import FilterMultiselect from "./multiselect";
import Classes from "classnames";
import React from "react";


export default class FilterSelectorRating extends FilterMultiselect {

    render() {

        const options = this.props.filter.getFilterOptions();
        const curValue = this.props.filter.getValue();

        return (
            <div className="block-content filter-multiselect">

                {options.map(v=>{

                    const selected = curValue.includes(v.value);

                    let renderValue;
                    if (!v.value) renderValue = <div className="name" onClick={this.onItemClick.bind(this,v.value)}>{v.label}</div>;
                    else {
                        const stars = [];
                        for (let i=0; i<v.value; i++) {
                            stars.push(<div className="i5-star" key={i}></div>)
                        }
                        renderValue = <div className="gd-field-rating list" onClick={this.onItemClick.bind(this,v.value)}>{stars}</div>
                    }

                    return (
                        <div key={v.value} className={Classes("type-option", {'selected': selected})} >
                            <div className={Classes('gd-cb-12',{selected: selected})} onClick={this.onCheckboxClick.bind(this,v.value)}> </div>
                            {renderValue}
                            <div className="cf"> </div>
                        </div>
                    );
                })}

            </div>
        );
    }


}